import { render, staticRenderFns } from "./BajasCobranzaVerDetalle.vue?vue&type=template&id=0a76468a&"
import script from "./BajasCobranzaVerDetalle.vue?vue&type=script&lang=ts&"
export * from "./BajasCobranzaVerDetalle.vue?vue&type=script&lang=ts&"
import style0 from "./BajasCobranzaVerDetalle.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports